import type { ApiShopperLandingPage } from '@storefronts/common-types'
import Head from 'next/head'
import { buildOpenGraphTags } from '../../utils/openGraph'

export const LandingPageOpenGraph = ({
    landingPage,
}: {
    landingPage: ApiShopperLandingPage
}) => (
    <Head>
        {buildOpenGraphTags(landingPage).map(({ property, content }) => (
            <meta key={property} property={property} content={content} />
        ))}
    </Head>
)
